export default __webpack_public_path__ + "static/media/mighty_action_heroes_game_card.435996ff.jpg";